import { WIDGET_VIEW_SELECT } from "@smallstack/typesystem";
import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const SelectViewWidget: WidgetRegistryEntry = {
  name: WIDGET_VIEW_SELECT,
  component: () => import("./select-view-widget.component").then((m) => m.SelectViewWidgetComponent)
};
